import { useSearch } from "@tanstack/react-router";

import { useGetRequest } from "@/hooks/useGetRequest.tsx";

import { useUser } from "./useUser";

export function useGetCurrentProjectId(): number {
  const { ["project-id"]: projectId } = useSearch({ strict: false });

  const { data: user } = useUser();
  const { data: request } = useGetRequest();

  return (projectId ?? user?.currentProjectId ?? request?.projectId) as number;
}
